import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

type TitleProps = {
  href?: string;
  hasUrl?: boolean;
  blueText?: boolean;
  fontWeight?: number;
  fontSize?: number;
  isSubtitle?: boolean;
  hasPaddingBottom?: boolean;
  noWrap?: boolean;
  children?: ReactNode;
  onClick?: any;
};

export const Title = styled.a<TitleProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 0;
  font:
    400 33px 'Open Sans',
    sans-serif;
  color: ${({ theme }) => theme.palette.neutral.dark};
  letter-spacing: -0.04em;
  transition: all 0.1s linear;
  cursor: default;

  ${({ hasUrl, blueText, theme }) =>
    hasUrl &&
    css`
      cursor: pointer;
      color: ${blueText ? theme.palette.text.link : theme.palette.neutral.dark};

      :hover {
        color: ${theme.palette.text.link};
        font-weight: 600;
      }
    `}

  ${({ fontWeight }) =>
    fontWeight &&
    css`
      font-weight: ${fontWeight};
    `}

  ${({ fontSize }) =>
    fontSize &&
    css`
      font-size: ${fontSize}px;
    `}

  ${({ isSubtitle }) =>
    isSubtitle &&
    css`
      font-size: 20px;
    `}

  ${({ hasPaddingBottom }) =>
    hasPaddingBottom &&
    css`
      padding-bottom: 10px;
    `}

  ${({ noWrap }) =>
    noWrap &&
    css`
      text-wrap: nowrap;
    `}
`;

export default Title;
